import { ReferenceEntityInterface } from '../model/interfaces/reference-entity.interface';

export function GetReferenceEntitiesDisplay(
  referenceEntitiesArray: ReferenceEntityInterface[]
): number[] | [] {
  if (!referenceEntitiesArray || referenceEntitiesArray.length < 1) {
    return [];
  }
  return referenceEntitiesArray.map((entity) => entity.referenceEntityId);
}
